import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'
import type { Link } from '@/types'

type Args = {
  linkId: string
  payload: {
    slug: string
    destinations: string[]
    teamIds?: string
  }
}

export const useEditLink = () => {
  const queryClient = useQueryClient()

  return useMutation<Link, Error, Args>({
    mutationFn: async ({ linkId, payload }) => {
      const { data } = await api.patch(`/links/${linkId}`, payload)
      return data.data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({ queryKey: ['all-links'] })
      queryClient.invalidateQueries({ queryKey: ['link', args.linkId] })
    },
  })
}
